import { Component, inject, OnInit, signal } from '@angular/core';
import { ComplianceCreateComponent } from '../compliance-create/compliance-create.component';
import { ComplianceDocsService } from '../../../../services/compliance-docs/compliance-docs.service';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';
import { DatePipe } from '@angular/common';
import { environment } from '../../../../../environments/environment';
import { HasBoltOnDirectiveDirective } from '../../../../common/directives/has-bolt-on/has-bolt-on-directive.directive';
import { NotHasBoltOnDirectiveDirective } from '../../../../common/directives/not-has-bolt-on/not-has-bolt-on-directive.directive';
import { ChoosePlanService } from '../../../choose-plan/service/choose-plan/choose-plan.service';

@Component({
  selector: 'mb-compliance',
  standalone: true,
  imports: [ComplianceCreateComponent, DatePipe, HasBoltOnDirectiveDirective, NotHasBoltOnDirectiveDirective],
  templateUrl: './compliance.component.html',
  styleUrl: './compliance.component.css'
})
export class ComplianceComponent implements OnInit {

  environment = environment;

  showCreateComplianceModal = signal<boolean>(false);

  complianceService = inject(ComplianceDocsService);
  currentUserService = inject(CurrentUserService);
  private choosePlanService = inject(ChoosePlanService);

  allComplianceDocs = signal<any[] | undefined>(undefined);

  ngOnInit(): void {
    this.getComplianceDocs();
  }

  getComplianceDocs() {
    this.complianceService.getBrandComplianceDocs(this.currentUserService.focussedBrand.id, true).subscribe((response) => {
      console.log('Compliance docs: ', response);
      this.allComplianceDocs.set(response);
    }, (error) => {
      console.error('Error getting compliance docs: ', error);
    });
  }

  openCreateComplianceModal() {
    this.showCreateComplianceModal.set(true);
  }

  openChoosePlan() {
    // this.choosePlanService.addPreSelectedBoltOn(environment.stripe.shaas21products.bo_ai_moderation);
    // this.choosePlanService.subscribeModalOpen.set(true);
    this.choosePlanService.launchSubscribeOrBoltOn(environment.stripe.shaas21products.bo_ai_moderation);
  }
}
